export enum OpportunityContactRoleType {
  CO_ISSUER = 'CO_ISSUER',
  GROWER = 'GROWER',
  GUARANTOR = 'GUARANTOR',
  LANDLORD = 'LANDLORD',
  OTHER = 'OTHER',
  PRIMARY = 'PRIMARY',
  SPOUSE = 'SPOUSE'
}
